import { useState } from "react";
import type { Certification } from "../types";

/**
 * Custom hook for managing component state including sheets, expanders, and navigation
 * Consolidates state management for UI components across the application
 */
export const useComponentState = () => {
  const [isSheetOpen, setIsSheetOpen] = useState(false);

  const openSheet = () => {
    setIsSheetOpen(true);
  };

  const closeSheet = () => {
    setIsSheetOpen(false);
  };

  const toggleSheet = () => {
    setIsSheetOpen((prev) => !prev);
  };

  const [expandedItems, setExpandedItems] = useState<Set<number>>(new Set([0]));

  const handleExpanderChange = (index: number, isOpen: boolean) => {
    const newExpanded = new Set(expandedItems);
    if (isOpen) {
      newExpanded.add(index);
    } else {
      newExpanded.delete(index);
    }
    setExpandedItems(newExpanded);
  };

  const [selectedCertification, setSelectedCertification] =
    useState<Certification | null>(null);

  const handleCertificationSelect = (certification: Certification) => {
    setSelectedCertification(certification);
  };

  const handleBackToFeatures = () => {
    setSelectedCertification(null);
  };

  const clearSelection = () => {
    setSelectedCertification(null);
  };

  return {
    sheet: {
      isOpen: isSheetOpen,
      open: openSheet,
      close: closeSheet,
      toggle: toggleSheet,
    },
    expander: {
      expandedItems,
      handleExpanderChange,
    },
    certification: {
      selected: selectedCertification,
      select: handleCertificationSelect,
      goBack: handleBackToFeatures,
      clear: clearSelection,
    },
  };
};
